<template>
    <div class="flex flex-col h-full my-4">
        <div
            class="mx-4 border-neutral-base border rounded-lg p-4"
            :role="hasLink ? 'button' : undefined"
            :tabindex="hasLink ? 0 : undefined"
            data-cy="impersonation-selector"
            :class="{
                'cursor-pointer': hasLink,
            }"
            @click="onClick"
            @keydown.enter="onClick"
        >
            <div class="flex items-center">
                <UIAvatar :avatar="config.data.avatar" />
                <div class="ml-3 flex-1 min-w-0">
                    <div class="content-sm-ux-medium truncate">
                        {{ config?.data?.title }}
                    </div>
                    <div
                        v-if="config?.data?.subtitle"
                        class="content-sm-ux-regular text-neutral-extra-subtle truncate"
                    >
                        {{ config.data.subtitle }}
                    </div>
                </div>

                <PhIcon
                    v-if="hasLink"
                    icon="caret-down"
                    :size="15"
                    weight="bold"
                    class="inline-block ml-1"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import PhIcon from '@/components/app/PhIcon.vue'
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const props = defineProps({
        config: Object,
    })

    const emit = defineEmits(['click'])

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()
    const clicking = ref(false)

    const meta = computed(() => props.config?.meta)

    const hasLink = computed(() => {
        return !!props.config?.link
    })

    const onClick = async () => {
        if (clicking.value || !hasLink.value) {
            return
        }

        clicking.value = true
        moduleHelpers.handleClick(router, props.config, get(meta, ['value', 'id']), true)
            .catch((e) => {
                console.log('Failed to open impersonation selector link', e)
            })
            .finally(() => {
                clicking.value = false
            })

        emit('click')
    }

</script>
